import moment from 'moment'
import {
    LatestNewsItem,
    LatestNewsImageLink,
    LatestNewsImage,
    LatestNewsBody,
    LatestNewsTitle,
    LatestNewsDesc,
    CreatedDate
} from './newsItemElements'


const NewsItem = ({smrow, news, small, index, type, fixedheight}) => {
    
    return (
        <LatestNewsItem fixedheight={fixedheight} smrow={smrow} type={type}>
            <LatestNewsImageLink title={news.title} to={`/news/${news._id}`}>
                <LatestNewsImage smrow={smrow} src={news.image} alt={news.title} />
            </LatestNewsImageLink>
            <LatestNewsBody>
                <LatestNewsTitle title={news.title} to={`/news/${news._id}`}>{news.title}</LatestNewsTitle>
                <LatestNewsDesc className='hide-on-mobile'>{news.description}</LatestNewsDesc>
                <CreatedDate className='hide-on-mobile'>{moment(news.createdAt).fromNow()}</CreatedDate>
            </LatestNewsBody>
        </LatestNewsItem>
    )
}

export default NewsItem
